import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyOwnershipService {
  baseUrl: string = environment.API_SERVER;
  @Output() newAffiliateTypeAdded = new EventEmitter<any>();

  constructor(private _http: HttpClient) {}

  getCompanyTypes() {
    return this._http.get(this.baseUrl + '/ownership/company-types');
  }
  getGroupedObject() {
    return this._http.get(this.baseUrl + '/object-document/grouped');
  }
  getOwnershipTypes() {
    return this._http.get(this.baseUrl + '/ownership/ownership-types');
  }

  getAllOwnershipTypes() {
    return this._http.get(this.baseUrl + '/ownership/all');
  }

  getAllfinancialEnd(payload) {
    return this._http.get(
      this.baseUrl +
        `/organizations/aol/get-year-end/?organizationId=${payload.organizationId}`,
      payload.body
    );
  }
  çreateFinancialEnd(payload) {
    return this._http.post(
      this.baseUrl + `/organizations/aol/add-financial-year/`,
      payload.body
    );
  }
  getAllFinancialEnd(payload) {
    return this._http.get(
      this.baseUrl + `/organizations/aol/financial-years/`,
      { params: payload.params }
    );
  }
  publishFinancialYear(payload) {
    return this._http.get(
      this.baseUrl +
        `/organizations/aol/publish-year/?financialYear=${payload.year}`
    );
  }
  unPublishFinancialYear(payload) {
    return this._http.get(
      this.baseUrl +
        `/organizations/aol/unpublish-year/?financialYear=${payload.year}`
    );
  }
  getOwnershipsForCompanyType(payload: any) {
    return this._http.get(
      this.baseUrl + '/ownership/' + payload.companyTypeId + '/ownership-types'
    );
  }

  addOwnershipType(payload: any) {
    return this._http.post(this.baseUrl + '/ownership/add', {
      name: payload.name,
      description: payload.description,
    });
  }

  addOwnershipTypeToCompanyType(payload: {
    companyTypeId: string;
    affiliateTypeId: string;
  }) {
    return this._http.post(
      this.baseUrl +
        '/ownership/' +
        payload.companyTypeId +
        '/add/' +
        payload.affiliateTypeId,
      {}
    );
  }

  removeAffiliateTypeFromCompanyType(payload: {
    companyTypeHasOwnershipTypeId: string;
  }) {
    return this._http.delete(
      this.baseUrl +
        '/ownership/' +
        payload.companyTypeHasOwnershipTypeId +
        '/unlink'
    );
  }
}
